import { render, staticRenderFns } from "./pack-request.vue?vue&type=template&id=45be88e4&scoped=true"
import script from "./pack-request.vue?vue&type=script&lang=js"
export * from "./pack-request.vue?vue&type=script&lang=js"
import style0 from "./pack-request.vue?vue&type=style&index=0&id=45be88e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be88e4",
  null
  
)

export default component.exports